module.exports = __webpack_public_path__ + "img/signable_cropped_white.08b01da9.svg";